/* eslint-disable */

import moment from 'moment';
import { enums } from "../enums";

import { getOrganization, getDates } from "../actions";

import * as requestHelper from "../utils/requestHelper";
import { getNumberOfActiveOfficialCertificatesForDateRangeAndUtilityOrganization, getNumberOfActiveOfficialDailyCertificatesForDateRangeAndUtilityOrganization } from './CertificatesActions';

const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText); 
  }
  return response;
}

export const resetDemoData = () => (dispatch) => {
  dispatch({ type: 'RESET_DEMO_DATA' });
};

export const openDemoDataFormDialog = (demoData) => async dispatch => {
  if(demoData){
    dispatch({ type: 'GET_DEMO_DATA_SUCCESS', payload: demoData });
  } else {
    dispatch({ type: 'RESET_DEMO_DATA' });
  }
  dispatch({ type: 'OPEN_DEMO_DATA_FORM_DIALOG' });
};

export const closeDemoDataFormDialog = () => (dispatch) => {
  dispatch({ type: 'CLOSE_DEMO_DATA_FORM_DIALOG' });
  dispatch({ type: 'RESET_DEMO_DATA' });
};

export const toggleDemoDataFormDialog = () => (dispatch) => {
  dispatch({ type: 'TOGGLE_DEMO_DATA_FORM_DIALOG' });
};

export const toggleMaintenanceStartDateDialog = () => (dispatch) => {
  dispatch({ type: 'TOGGLE_MAINTENANCE_STARTDATE' });
};


export const toggleActionWarningDialog = () => (dispatch) => {
  dispatch({ type: 'TOGGLE_MAINTENANCE_WARNING' });
};

const triggerUpdateDemoScript = async (startDate, endDate) => {

  let formattedStartDate = moment(startDate).format("YYYY-MM-DD");
  let formattedEndDate = moment(endDate).format("YYYY-MM-DD");
  let url = `${process.env.REACT_APP_API_URL}/api/demo/update?save=true&start=${formattedStartDate}&end=${formattedEndDate}`;

  let resUpdate = await fetch(
    url,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
  .then(handleErrors)
  .then(res => res.json())
  .then(async matchingRes => {
    return matchingRes
  })
  .catch(error => {
    console.error(error);
    throw Error(error);
  });
  
  return resUpdate

};

const getUtilityOrganizationBalanceAccount = async (organizationId) => {
  if(!organizationId) {
    throw new Error(`Please specify an organization id : ${organizationId}`);
  }

  let url = `${process.env.REACT_APP_API_URL}/api/organizations/${organizationId}/balance`;

  let balance = await fetch(
    url,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    }
  )
  .then(handleErrors)
  .then(res => res.json())
  .then(async balanceRes => {
    return balanceRes
  })
  .catch(error => {
    console.error(error);
    throw Error(error);
  });
  
  return balance
};

const triggerMatchingScript = async (startDate_orSingleDay, endDate, organizationId, status, issueComment) => {
  let endpointUrl = "/api/maintenance/matching";
  let organization = null;

  if(!organizationId) {
    throw new Error(`Please specify an organization.`);
  }
  
  organization = await getOrganization(organizationId)

  if(!organization) {
    throw new Error("Organization not found"); 
  }

  let singleDay = false;

  let startDate_YYYYMMDD = moment(startDate_orSingleDay).format('YYYY-MM-DD');
  let endDate_YYYYMMDD = moment(endDate).format('YYYY-MM-DD');

  if(startDate_YYYYMMDD == endDate_YYYYMMDD) {
    singleDay = true;
  }
  
  let numberOfActiveOfficialCertificates = await getNumberOfActiveOfficialCertificatesForDateRangeAndUtilityOrganization(startDate_YYYYMMDD, endDate_YYYYMMDD, organization);

  if(numberOfActiveOfficialCertificates > 0) {
    throw new Error(`There are active official certificates for this date range and utility organization ! : ${numberOfActiveOfficialCertificates}`);
  }
  
  let body = {
    nbRetry: 10,
    generateCertificates: true,
    forceIfExistingCertificates: true,
    utilityOrganizationName: organization.name,
    singleDay: singleDay,
    singleDateUTCMidnight_YYYYMMDD: startDate_YYYYMMDD,
    startDateUTCMidnight_YYYYMMDD: startDate_YYYYMMDD,
    endDateUTCMidnight_YYYYMMDD: endDate_YYYYMMDD,
    status: status,
    issueComment: issueComment
  }
  
  let json = JSON.stringify(body);
  
  await fetch(
    process.env.REACT_APP_API_URL + endpointUrl,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
  .then(handleErrors)
  .then(res => res.json())
  .then(async matchingRes => {
    return matchingRes
  })
  .catch(error => {
    console.error(error);
    throw Error(error);
  });
    
  return({status: "ok", function: "triggerMatchingLiveAllOrganizationsScript"})
};

const triggerGeneratePdfCertificatesScript = async (startMonth, startYear, endMonth, endYear, organizationId, destination) => {
  try {
    let startMonthArg = startMonth < 10 ? "0"+startMonth : startMonth
    let endMonthArg = endMonth < 10 ? "0"+endMonth : endMonth
    let destinationArg = destination ? destination : 'local'
    let endpointUrl = `/api/pdf-certificates/generate/${organizationId}?start=${startYear}-${startMonthArg}&end=${endYear}-${endMonthArg}&destination=${destinationArg}`;
    let organization = null;

    if(!organizationId) {
      throw new Error(`Please specify an organization.`);
    }
    
    organization = await getOrganization(organizationId)

    if(!organization) {
      throw new Error("Organization not found"); 
    }

    let response = await fetch( process.env.REACT_APP_API_URL + endpointUrl, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    })
    if (!response.ok) throw Error(response.statusText);
    
    let data = await response.json();
    
      
    return({status: "ok", function: "triggerGeneratePdfCertificatesScript"})

  } catch (error) {
    
    let errorMessage = `Error during launching action, ${error}`;
    throw Error(errorMessage);
  }

};
const triggerIncrementalMatchingScript = async (startDate_orSingleDay, endDate, organizationId, status, issueComment) => {
  let endpointUrl = "/api/maintenance/matching/incremental";
  let organization = null;

  if(!organizationId) {
    throw new Error(`Please specify an organization.`);
  }
  
  organization = await getOrganization(organizationId)

  if(!organization) {
    throw new Error("Organization not found"); 
  }

  let singleDay = false;

  let startDate_YYYYMMDD = moment(startDate_orSingleDay).format('YYYY-MM-DD');
  let endDate_YYYYMMDD = moment(endDate).format('YYYY-MM-DD');

  if(startDate_YYYYMMDD == endDate_YYYYMMDD) {
    singleDay = true;
  }
  
  let numberOfActiveOfficialCertificates = await getNumberOfActiveOfficialCertificatesForDateRangeAndUtilityOrganization(startDate_YYYYMMDD, endDate_YYYYMMDD, organization);

  if(numberOfActiveOfficialCertificates == 0) {
    throw new Error(`No active official certificates for this date range and utility organization ! Incremental matching cannot be performed`);
  }
  
  let body = {
    nbRetry: 10,
    generateCertificates: true,
    forceIfExistingCertificates: true,
    utilityOrganizationName: organization.name,
    singleDay: singleDay,
    singleDateUTCMidnight_YYYYMMDD: startDate_YYYYMMDD,
    startDateUTCMidnight_YYYYMMDD: startDate_YYYYMMDD,
    endDateUTCMidnight_YYYYMMDD: endDate_YYYYMMDD,
    status: status,
    issueComment: issueComment
  }
  
  let json = JSON.stringify(body);
  
  await fetch(
    process.env.REACT_APP_API_URL + endpointUrl,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
  .then(handleErrors)
  .then(res => res.json())
  .then(async matchingRes => {
    return matchingRes
  })
  .catch(error => {
    console.error(error);
    throw Error(error);
  });
    
  return({status: "ok", function: "triggerIncrementalMatchingScript"})
};

const triggerDailyCertificateGenerationScript = async (startDate_orSingleDay, endDate, organizationId, status, issueComment) => { 
  let endpointUrl = "/api/maintenance/daily-certificate-generation";
  let organization = null;

  if(!organizationId) {
    throw new Error(`Please specify an organization.`);
  }
  
  organization = await getOrganization(organizationId)

  if(!organization) {
    throw new Error("Organization not found"); 
  }

  let singleDay = false;

  let startDate_YYYYMMDD = moment(startDate_orSingleDay).format('YYYY-MM-DD');
  let endDate_YYYYMMDD = moment(endDate).format('YYYY-MM-DD');

  if(startDate_YYYYMMDD == endDate_YYYYMMDD) {
    singleDay = true;
  }

  let numberOfActiveOfficialCertificates = await getNumberOfActiveOfficialDailyCertificatesForDateRangeAndUtilityOrganization(startDate_YYYYMMDD, endDate_YYYYMMDD, organization);

  if(numberOfActiveOfficialCertificates > 0) {
    throw new Error(`There are active official daily certificates for this date range and utility organization ! : ${numberOfActiveOfficialCertificates}`);
  }
  
  let body = {
    nbRetry: 10,
    forceIfExistingCertificates: true,
    utilityOrganizationName: organization.name,
    singleDay: singleDay,
    singleDateUTCMidnight_YYYYMMDD: startDate_YYYYMMDD,
    startDateUTCMidnight_YYYYMMDD: startDate_YYYYMMDD,
    endDateUTCMidnight_YYYYMMDD: endDate_YYYYMMDD,
    status: status,
    issueComment: issueComment
  }
  
  let json = JSON.stringify(body);
  
  await fetch(
    process.env.REACT_APP_API_URL + endpointUrl,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
  .then(handleErrors)
  .then(res => res.json())
  .then(async certificateGenerationRes => {
    return certificateGenerationRes
  })
  .catch(error => {
    console.error(error);
    throw Error(error);
  });
    
  return({status: "ok", function: "triggerDailyCertificateGenerationScript"})
};

const triggerCancelCertificatesAllOrganizationsScript = async (startDate, endDate, cancelComment) => {
  let daysArray = getDates(startDate, endDate);

  for (let currentDay of daysArray) {
    let body = {
      "day": moment(currentDay).format("YYYY-MM-DD"),
      "cancelComment": cancelComment
    }

    let json = JSON.stringify(body);
  
    await fetch(
      process.env.REACT_APP_API_URL +
      "/api/maintenance/retire-certificates-for-day",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        body: json
      }
    )
    .then(handleErrors)
    .then(res => res.json())
    .then(async matchingRes => {
      return matchingRes
    })
    .catch(error => {
      console.error(error);
      throw Error(error);
    });
  }

  return({status: "ok", function: "triggerCancelCertificatesAllOrganizationsScript"})

};

const triggerCancelCertificatesOneOrganizationScript = async (startDate, endDate, organizationId, cancelComment) => {
  let body = {
    "startDate": moment(startDate).format("YYYY-MM-DD"),
    "endDate": moment(endDate).format("YYYY-MM-DD"),
    "organizationId": organizationId,
    "cancelComment": cancelComment
  }

  let url = process.env.REACT_APP_API_URL + "/api/maintenance/retire-certificates-for-date-range-and-organization";

  await requestHelper.postJsonRequest(url, body);

  return({status: "ok", function: "triggerCancelCertificatesOneOrganizationScript"})
};

const triggerCancelCertificatesAndReplayLiveAllOrganizationsScript = async (startDate, endDate, cancelComment) => {
  throw new Error(`Deprecated function.`);

  await triggerCancelCertificatesAllOrganizationsScript(startDate, endDate, cancelComment)
  await triggerMatchingScript(startDate, endDate, null, "live", cancelComment)

  return({status: "ok", function: "triggerCancelCertificatesAndReplayLiveAllOrganizationsScript"})

};

const triggerCancelLiveCertificatesAndReplayOneOrganizationScript = async (startDate, endDate, organizationId, cancelComment) => {
  throw new Error(`Deprecated function.`);

  await triggerCancelCertificatesOneOrganizationScript(startDate, endDate, organizationId, cancelComment)
  await triggerMatchingScript(startDate, endDate, organizationId, "live", cancelComment)

  return({status: "ok", function: "triggerCancelLiveCertificatesAndReplayOneOrganizationScript"})

};

const triggerCancelCertificatesAndReplayOfficialAllOrganizationsScript = async (startDate, endDate, cancelComment) => {
  throw new Error(`Deprecated function.`);

  await triggerCancelCertificatesAllOrganizationsScript(startDate, endDate, cancelComment)
  await triggerMatchingScript(startDate, endDate, null, "official", cancelComment)

  return({status: "ok", function: "triggerCancelCertificatesAndReplayOfficialAllOrganizationsScript"})
};

const triggerCancelOfficialCertificatesAndReplayOneOrganizationScript = async (startDate, endDate, organizationId, cancelComment) => {
  throw new Error(`Deprecated function.`);

  await triggerCancelCertificatesOneOrganizationScript(startDate, endDate, organizationId, cancelComment)
  await triggerMatchingScript(startDate, endDate, organizationId, "official", cancelComment)

  return({status: "ok", function: "triggerCancelOfficialCertificatesAndReplayOneOrganizationScript"})
};

export const triggerMaintenanceScript = (startDate, endDate, organizationId, actionId, comment) => async dispatch => {
  try {

    let log = {
      level: "info",
      comment,
      organization: organizationId,
    }
    let startDate_YYYYMMDD = moment(startDate).format('YYYY-MM-DD');
    let endDate_YYYYMMDD = moment(endDate).format('YYYY-MM-DD');
    log.startDate = startDate_YYYYMMDD;
    log.endDate = endDate_YYYYMMDD;

    dispatch({ type: 'MAINTENANCE_ACTION_START' });

    switch (actionId) {
      case enums.MaintenanceActionTypes.MATCHING_LIVE:
        await triggerMatchingScript(startDate, endDate, organizationId, "live", comment)
        log.action =  "matching_live"; 
        await createLog(log)
        break;
  
      case enums.MaintenanceActionTypes.MATCHING_OFFICIAL:
        await triggerMatchingScript(startDate, endDate, organizationId, "official", comment)
        log.action =  "matching_official";
        await createLog(log)
        break;
  
      case enums.MaintenanceActionTypes.UPDATE_DEMO:
        await triggerUpdateDemoScript(startDate, endDate)
        log.action =  "update_demo";
        await createLog(log)
        break;
  
      case enums.MaintenanceActionTypes.CANCEL_CERTIFICATES:
        await triggerCancelCertificatesOneOrganizationScript(startDate, endDate, organizationId, comment)
        log.action =  "cancel_certificates";
        await createLog(log)
        break;

      case enums.MaintenanceActionTypes.INCREMENTAL_MATCHING_OFFICIAL:
        await triggerIncrementalMatchingScript(startDate, endDate, organizationId, "official", comment)
        log.action =  "incremental_matching";
        await createLog(log)
        break;
      case enums.MaintenanceActionTypes.DAILY_OFFICIAL_CERTIFICATE_GENERATION:
        await triggerDailyCertificateGenerationScript(startDate, endDate, organizationId, "official", comment)
        log.action =  "daily_official_certificate_generation";
        await createLog(log)
        break;
      case enums.MaintenanceActionTypes.DAILY_LIVE_CERTIFICATE_GENERATION:
        await triggerDailyCertificateGenerationScript(startDate, endDate, organizationId, "live", comment)
        log.action =  "daily_live_certificate_generation";
        await createLog(log)
        break;
  
      default:
        dispatch({ type: 'TOGGLE_MAINTENANCE_WARNING' });
        dispatch({ type: 'OPEN_ERROR', payload: 'No action provided' });
    }
    dispatch({ type: 'MAINTENANCE_ACTION_END' });
    dispatch({ type: 'TOGGLE_MAINTENANCE_WARNING' });
    dispatch({ type: 'OPEN_SUCCESS', payload: 'Maintenance action now running in background, please wait...' });

  } catch (error) {
    let errorMessage = `Error during launching action, ${error}`;
    
    dispatch({ type: 'MAINTENANCE_ACTION_END' });
    dispatch({ type: 'OPEN_ERROR', payload: errorMessage });
  }
};

export const triggerGeneratePdfCertificatesReportScript = (startMonth, startYear, endMonth, endYear, organizationId, destination) => async dispatch => {
  try {
    dispatch({ type: 'MAINTENANCE_PDF_CERTIFICATES_GENERATION_ACTION_START' });
    await triggerGeneratePdfCertificatesScript(startMonth, startYear, endMonth, endYear, organizationId, destination)
    
    dispatch({ type: 'MAINTENANCE_PDF_CERTIFICATES_GENERATION_ACTION_END' });
    dispatch({ type: 'OPEN_SUCCESS', payload: 'PDF certificates for report have been generated' });

  } catch (error) {
    let errorMessage = `Error during launching action, ${error}`;
    
    dispatch({ type: 'MAINTENANCE_PDF_CERTIFICATES_GENERATION_ACTION_END' });
    dispatch({ type: 'OPEN_ERROR', payload: errorMessage });
  }
};
export const toggleMaintenanceEndDateDialog = () => (dispatch) => {
  dispatch({ type: 'TOGGLE_MAINTENANCE_ENDDATE' });
};

export const setMaintenanceStartDate = (startDate) => (dispatch) => {
  dispatch({ type: 'SET_MAINTENANCE_STARTDATE', payload: startDate });
};

export const setMaintenanceEndDate = (endDate) => (dispatch) => {
  dispatch({ type: 'SET_MAINTENANCE_ENDDATE', payload: endDate });
};

export const setSelectedTab = (tab) => (dispatch) => {
  dispatch({ type: 'SET_TAB', payload: tab });
};

export const setLoadingExportProdData = (loading) => (dispatch) => {
  dispatch({ type: 'SET_LOADING_EXPORT_PROD_DATA', payload: loading });
};

export const setExportProdStartDate = (startDate) => (dispatch) => {
  dispatch({ type: 'SET_EXPORT_PROD_STARTDATE', payload: startDate });
};

export const setExportProdEndDate = (endDate) => (dispatch) => {
  dispatch({ type: 'SET_EXPORT_PROD_ENDDATE', payload: endDate });
};

export const matchingOrganizationChanged = (organizationId) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_MATCHING_ORGANIZATION_CHANGED', payload: organizationId });
};

export const generatePdfCertificatesMonthlyReportOrganizationChanged = (organizationId) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_GENERATE_PDF_REPORT_ORGANIZATION_CHANGED', payload: organizationId });
};

export const generatePdfCertificatesMonthlyReportStartMonthChanged = (startMonth) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_GENERATE_PDF_REPORT_START_MONTH_CHANGED', payload: startMonth });
};

export const generatePdfCertificatesMonthlyReportStartYearChanged = (startYear) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_GENERATE_PDF_REPORT_START_YEAR_CHANGED', payload: startYear });
};

export const generatePdfCertificatesMonthlyReportEndMonthChanged = (endMonth) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_GENERATE_PDF_REPORT_END_MONTH_CHANGED', payload: endMonth });
};

export const generatePdfCertificatesMonthlyReportEndYearChanged = (endYear) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_GENERATE_PDF_REPORT_END_YEAR_CHANGED', payload: endYear });
};

export const generatePdfCertificatesMonthlyReportDestinationChanged = (destination) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_GENERATE_PDF_REPORT_DESTINATION_CHANGED', payload: destination });
};

export const reportOrganizationChanged = (organizationId) => (dispatch) => {
  dispatch({ type: 'REPORT_ORGANIZATION_CHANGED', payload: organizationId });
};

export const reportUnitChanged = (unit) => (dispatch) => {
  dispatch({ type: 'REPORT_UNIT_CHANGED', payload: unit });
};

export const actionChanged = (actionId) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_ACTION_CHANGED', payload: actionId });
};


export const commentChanged = (comment) => (dispatch) => {
  dispatch({ type: 'MAINTENANCE_COMMENT_CHANGED', payload: comment });
};

export const openDemoDataDeleteWarningDialog = (demoData) => async dispatch => {
  dispatch({ type: 'GET_DEMO_DATA_SUCCESS', payload: demoData });
  dispatch({ type: 'OPEN_DEMO_DATA_DELETE_WARNING_DIALOG' });
};

export const closeDemoDataDeleteWarningDialog = () => (dispatch) => {
  dispatch({ type: 'CLOSE_DEMO_DATA_DELETE_WARNING_DIALOG' });
  dispatch({ type: 'RESET_DEMO_DATA' });
};

export const toggleDemoDataDeleteWarningDialog = () => (dispatch) => {
  dispatch({ type: 'TOGGLE_DEMO_DATA_DELETE_WARNING_DIALOG' });
};

export const energyDataChanged = (energyDataStringArray) => (dispatch) => {
  dispatch({ type: 'DEMO_DATA_ENERGY_DATA_CHANGED', payload: energyDataStringArray });
};

export const demoDataAssetIdChanged = (assetID) => (dispatch) => {
  dispatch({ type: 'DEMO_DATA_ASSET_ID_CHANGED', payload: assetID });
};

export const demoDataTypeChanged = (productionType) => (dispatch) => {
  dispatch({ type: 'DEMO_DATA_TYPE_CHANGED', payload: productionType });
};


export const datasetChanged = file => dispatch => {
  dispatch({ type: "DATASET_CHANGED", payload: file });
};

export const uploadDatasetStart = (file) => async dispatch => {

  dispatch({ type: 'UPLOAD_DATASET_START' });
  if (file) {
    let datasetFileName = await uploadDataset(file);
    dispatch({ type: 'UPLOAD_DATASET_SUCCESS' });
    dispatch({ type: 'OPEN_SUCCESS', payload: 'Dataset uploaded !' });
  } else {
    dispatch({ type: 'OPEN_ERROR', payload: 'No dataset provided' });
  }
}


export const uploadDataset = async (file) => {

  var formData = new FormData();
  formData.append("files", file);

  const datasetFileName = await fetch(
    process.env.REACT_APP_API_URL + "/api/demo/upload-dataset",
    {
      method: "POST",
      credentials: "include",
      body: formData
    }
  )
    .then(function (response) {
      return response.json();
    })
    .then(function (body) {
      return body;
    });

  return datasetFileName;
};

export const createDemoData = (demoData) => async dispatch => {
  let json = JSON.stringify(demoData);
  dispatch({ type: 'CREATE_DEMO_DATA_START' });

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/api/demo/data",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(async demoDataRes => {
      dispatch({ type: 'CREATE_DEMO_DATA_SUCCESS', payload: demoDataRes });
      dispatch({ type: 'OPEN_SUCCESS', payload: "New demo data created" });
      return demoDataRes
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'CREATE_DEMO_DATA_FAIL', payload: demoData });
      dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
    });

}

export const updateDemoData = (demoData) => async dispatch => {
  let json = JSON.stringify(demoData);
  dispatch({ type: 'UPDATE_DEMO_DATA_START' });

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/api/demo/data/" + demoData._id,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(async demoDataRes => {
      dispatch({ type: 'UPDATE_DEMO_DATA_SUCCESS', payload: demoDataRes });
      dispatch({ type: 'OPEN_SUCCESS', payload: "Demo data updated" });
      return demoDataRes
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'UPDATE_DEMO_DATA_FAIL', payload: demoData });
      dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
    });

}

export const deleteDemoData = (demoData) => async dispatch => {
  let json = JSON.stringify(demoData);
  dispatch({ type: 'DELETE_DEMO_DATA_START' });

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/api/demo/data/" + demoData._id,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(async demoDataRes => {
      dispatch({ type: 'DELETE_DEMO_DATA_SUCCESS', payload: demoDataRes });
      dispatch({ type: 'OPEN_SUCCESS', payload: "Demo data deleted" });
      return demoDataRes
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'DELETE_DEMO_DATA_FAIL', payload: demoData });
      dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
    });

}

export const getSelectedOrganizationBalanceAccount = (organizationId) => async dispatch => {
  
  dispatch({ type: 'GET_UTILITY_ORGANIZATION_BALANCE_ACCOUNT_START' });

  try {
    let balance = await getUtilityOrganizationBalanceAccount(organizationId);
    dispatch({ type: 'GET_UTILITY_ORGANIZATION_BALANCE_ACCOUNT_SUCCESS', payload: balance });
  } catch (error) {
    console.error(error)
    dispatch({ type: 'GET_UTILITY_ORGANIZATION_BALANCE_ACCOUNT_FAIL' });
    dispatch({ type: 'OPEN_ERROR', payload: "Enable to get balance account for this organization" });
  }
}

export const getDemoDataList = () => async dispatch => {
  dispatch({ type: 'GET_DEMO_DATA_LIST_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/demo/data", {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async demoDataList => {
      getDemoDataListSuccess(demoDataList, dispatch);
      return demoDataList
    })
    .catch(error => {
      console.error(error);
      getDemoDataListFail(error, dispatch);
    });
}

export const getDemoDataListSuccess = (demoDataList, dispatch) => {
  dispatch({ type: 'GET_DEMO_DATA_LIST_SUCCESS', payload: demoDataList });
};

export const getDemoDataListFail = (error, dispatch) => {
  dispatch({ type: 'GET_DEMO_DATA_LIST_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};

export const getDemoData = (demoDataId) => async dispatch => {
  dispatch({ type: 'GET_DEMO_DATA_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/demo/data/"+demoDataId, {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async demoData => {
      getDemoDataSuccess(demoData, dispatch);
      return demoData
    })
    .catch(error => {
      console.error(error);
      getDemoDataFail(error, dispatch);
    });
}

export const getDemoDataSuccess = (demoData, dispatch) => {
  dispatch({ type: 'GET_DEMO_DATA_SUCCESS', payload: demoData });
};

export const getDemoDataFail = (error, dispatch) => {
  dispatch({ type: 'GET_DEMO_DATA_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};

export const createLog = async (log) => {
  let json = JSON.stringify(log);

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/api/logs",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(async logRes => {
      return logRes
    })
    .catch(error => {
      console.error(error);
    });

}

export const updateLog = (log) => async dispatch => {
  let json = JSON.stringify(log);
  dispatch({ type: 'UPDATE_LOG_START' });

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/api/logs/" + log._id,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(async logRes => {
      dispatch({ type: 'UPDATE_LOG_SUCCESS', payload: logRes });
      dispatch({ type: 'OPEN_SUCCESS', payload: "Log updated" });
      return logRes
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'UPDATE_LOG_FAIL', payload: log });
      dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
    });

}

export const deleteLog = (log) => async dispatch => {
  let json = JSON.stringify(log);
  dispatch({ type: 'DELETE_LOG_START' });

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/api/logs/" + log._id,
    {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(async logRes => {
      dispatch({ type: 'DELETE_LOG_SUCCESS', payload: logRes });
      dispatch({ type: 'OPEN_SUCCESS', payload: "Log deleted" });
      return logRes
    })
    .catch(error => {
      console.error(error);
      dispatch({ type: 'DELETE_LOG_FAIL', payload: log });
      dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
    });

}

export const getLogList = () => async dispatch => {
  dispatch({ type: 'GET_LOG_LIST_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/logs", {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async logList => {
      let logListSorted = logList.sort(function (a, b) {
        //sort by date, desc
        let sortDateCheck = moment(b.creation_date).format('x') - moment(a.creation_date).format('x');
        return sortDateCheck
      });
      getLogListSuccess(logListSorted, dispatch);
      return logListSorted
    })
    .catch(error => {
      console.error(error);
      getLogListFail(error, dispatch);
    });
}

export const getLogListSuccess = (logList, dispatch) => {
  dispatch({ type: 'GET_LOG_LIST_SUCCESS', payload: logList });
};

export const getLogListFail = (error, dispatch) => {
  dispatch({ type: 'GET_LOG_LIST_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};

export const getLog = (logId) => async dispatch => {
  dispatch({ type: 'GET_LOG_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/logs/"+logId, {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async log => {
      getLogSuccess(log, dispatch);
      return log
    })
    .catch(error => {
      console.error(error);
      getLogFail(error, dispatch);
    });
}

export const getLogSuccess = (log, dispatch) => {
  dispatch({ type: 'GET_LOG_SUCCESS', payload: log });
};

export const getLogFail = (error, dispatch) => {
  dispatch({ type: 'GET_LOG_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};



// WEBPACK FOOTER //
// ./src/actions/MaintenanceActions.js